import angular  from 'angular'
import uiRouter from 'angular-ui-router'

import component from './my-purchase-records.component'

let module = angular.module('myPurchaseRecords', [
  uiRouter
])

.config(($stateProvider) => {
  'ngInject'

  $stateProvider
    .state('vehicle.manageMyRlink.myPurchaseRecords', {
      url: '/history',
      component: 'myPurchaseRecords',
      authenticate: true
    })
})

.component('myPurchaseRecords', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/vehicle/manage-my-rlink/my-purchase-records/index.js